'use client';

import { useState } from 'react';
import { useForesight, type ForesightOptions } from '@foresightjs/react';
import { createPath, PrefetchPageLinks, type LinkProps } from 'react-router';
import { Link, useSiteAwareTo } from './index';

export type ForesightLinkProps = Omit<LinkProps, 'prefetch'> & Omit<ForesightOptions, 'callback'>;

export function ForesightLink({ to, hitSlop, name, meta, reactivateAfter, enabled, ...linkProps }: ForesightLinkProps) {
    const resolvedTo = useSiteAwareTo(to);
    const page = typeof resolvedTo === 'string' ? resolvedTo : createPath(resolvedTo);
    const [pageToPrefetch, setPageToPrefetch] = useState<string | null>(null);
    const { elementRef } = useForesight<HTMLAnchorElement>({
        callback: () => setPageToPrefetch(page),
        hitSlop,
        name,
        meta,
        reactivateAfter,
        enabled,
    });

    return (
        <>
            {pageToPrefetch === page && <PrefetchPageLinks page={page} />}
            <Link {...linkProps} ref={elementRef} to={to} />
        </>
    );
}
